import React from 'react';
import {ModalM} from "@common/components/modal/ModalM";
import TextM from "@common/components/text/TextM";
import FilledButtonM from "@common/components/button/FilledButtonM";
import {Dimensions, Linking, Platform, View} from "react-native";
import {ChampionImageM} from "../../../student/champions/ChampionImageM";
import {theme} from "@common/theme/theme";
import {IS_WEB} from "@common/utils/mobileUtils";
import {connect} from "react-redux";
import Constants from "expo-constants";

const VersionUpdateModal = (props) => {

    const visible = true
    const onPress = () => {
        if (IS_WEB) {
            // just reload
            window.location.reload();
        } else {

            const storeUrl = Platform.OS === 'ios' ? (props.iosAppUrl ?? Constants.expoConfig.ios.appStoreUrl) : (props.androidAppUrl ?? Constants.expoConfig.android.playStoreUrl)

            Linking.canOpenURL(storeUrl)
                .then(() => {
                    Linking.openURL(storeUrl).then();
                })
                .catch();
        }
    };
    return (
        <ModalM visible={visible}
                style={{width: Dimensions.get("window").width, height: Dimensions.get("window").height}}>
            <View style={{
                padding: 20
            }}>
                <View style={{
                    // flex: 1,
                    alignItems: "center",
                    justifyContent: "flex-start"
                }}>
                    <ChampionImageM name="sam" variant={"main"} width={140}/>
                    <TextM fontWeight="Bold"
                           fontSize={18}
                           wrap
                           style={{
                               paddingHorizontal: 10,
                               marginTop: 10,
                               textAlign: "center"
                           }}
                           color={theme.colors.sam}>
                        Une nouvelle version est disponible
                    </TextM>
                    <TextM fontWeight="Regular"
                           fontSize={16}
                           wrap
                           style={{
                               paddingHorizontal: 10,
                               marginTop: 4,
                               textAlign: "center"
                           }}>
                        {IS_WEB ? "Merci d'actualiser la page pour mettre à jour l'application !" : "Merci de mettre à jour l'application !"}
                    </TextM>
                </View>
                <FilledButtonM
                    style={{
                        width: "100%",
                        marginTop: 30
                    }}
                    onPress={onPress}
                    label={IS_WEB ? "Actualiser" : "Mettre à jour"}
                    //mode="outlined"
                />
            </View>
        </ModalM>
    )
};

const mapStateToProps = state => {
    return {
        androidAppUrl: state.data.staticData?.android_app_url,
        iosAppUrl: state.data.staticData?.ios_app_url
    }
}

const mapDispatchToProps =
    {}

export default connect(mapStateToProps, mapDispatchToProps)(VersionUpdateModal)